import {IIsInitialSetAction} from './types';
import {AT_IS_INITIAL_SET} from './constants';

export const isInitialSetAction = (
    isInitial: boolean
): IIsInitialSetAction => ({
    type: AT_IS_INITIAL_SET,
    isInitial
});
